(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["tracking"] = factory();
	else
		root["tracking"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	// The require scope
/******/ 	var __webpack_require__ = {};
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  gtm: () => (/* reexport */ gtm)
});

;// CONCATENATED MODULE: ./src/gtm.js
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Assign and apply the default properties including overrides.
 *
 * @param {Object} overrides
 * @param {Object} defaults
 * @return {Object}
 */
function assignProperties() {
  var overrides = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _objectSpread(_objectSpread({}, defaults), overrides);
}
var Tracking = {
  /**
   * Default properties to send with every event.
   */
  defaultProperties: {},
  /**
   * Initialize the GTM tracking script a.k.a the GTM Snippet.
   *
   * @param {String} tagId
   * @return {void}
   */
  init: function init(tagId) {
    /* eslint-disable */
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', tagId, {
      /**
       * We disable automatic page view events in favour of
       * creating them ourselves. This allows us to pass additional
       * data with each event.
       */
      send_page_view: false
    });
    /* eslint-enable */
  },
  /**
   * Configure the default properties to use for all tracking calls.
   *
   * @param {Object} properties
   * @return {void}
   */
  setDefaultProperties: function setDefaultProperties(properties) {
    Tracking.defaultProperties = properties;
  },
  /**
   * Track an event.
   *
   * @param  {String} event
   * @param  {Object} properties
   */
  track: function track(event) {
    var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(_objectSpread({
      event: event
    }, assignProperties(properties, Tracking.defaultProperties)));
  },
  /**
   * Track a page view.
   */
  trackPage: function trackPage() {
    var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    window.dataLayer = window.dataLayer || [];
    var href = url || window.location.href;
    var parser = document.createElement('a');
    parser.href = href;
    window.dataLayer.push(_objectSpread({
      event: 'page_view',
      url: href,
      path: parser.pathname,
      search: parser.search
    }, assignProperties(properties, Tracking.defaultProperties)));
  }
};
/* harmony default export */ const gtm = (Tracking);
;// CONCATENATED MODULE: ./src/index.ts



/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map